/**
 * Page size used by callers that need the complete list rather than one page
 * (lookup lists, autocompletes, side navigations that filter client-side).
 *
 * The backend defaults to a page size of 20, so these callers must ask for a
 * larger page explicitly. Raise this if a list can legitimately exceed it.
 */
export const FETCH_ALL_PAGE_SIZE = 1000;
